import React, { useEffect, useState } from "react";
import { Tag, Copy } from "lucide-react";
import { toast } from "sonner";
import { proApi } from "@/lib/proApi";

export const useMyCode = () => {
  const [code, setCode] = useState(null);
  useEffect(() => { proApi.get("/pro/my-code").then(({ data }) => setCode(data?.status === "active" ? data : null)).catch(() => {}); }, []);
  return code;
};

export const ProMyCodeCard = ({ className = "" }) => {
  const c = useMyCode();
  if (!c?.code) return null;
  const copy = () => navigator.clipboard?.writeText(c.code).then(() => toast.success("Code copié"));
  return (
    <div data-testid="pro-my-code" className={`rounded-2xl bg-[var(--oz-dark)] text-white p-5 sm:p-6 flex flex-col sm:flex-row sm:items-center gap-4 ${className}`}>
      <Tag className="w-6 h-6 text-[var(--oz-gold)] shrink-0" />
      <div className="flex-1">
        <p className="text-xs uppercase tracking-[0.16em] text-[var(--oz-gold)] font-semibold">Votre code personnel -{c.percent} %</p>
        <p data-testid="pro-my-code-value" className="mt-1 font-mono text-xl tracking-wider">{c.code}</p>
        <p className="mt-1 text-xs text-white/60">Réservé à votre compte, sur toutes vos commandes Ozentya (produits, hors livraison).</p>
      </div>
      <button onClick={copy} data-testid="pro-my-code-copy" className="inline-flex items-center gap-2 rounded-full bg-[var(--oz-gold)] text-[var(--oz-dark)] px-4 py-2 text-sm font-semibold hover:opacity-90 transition-opacity">
        <Copy className="w-4 h-4" /> Copier
      </button>
    </div>
  );
};
